import React, { useEffect, useState } from 'react';
import http from '../services/http';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from "../../components/base/Navbar";
import Footer from "../../components/base/Footer";

const months = [
  "Januar", "Februar", "März", "April", "Mai", "Juni",
  "Juli", "August", "September", "Oktober", "November", "Dezember"
];

const NewsletterList = () => {
  const { year } = useParams();
  const navigate = useNavigate();

  const [vis, setVis] = useState({}); // { [month:number]: boolean }
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await http.get(`/api/admin/newsletter/${year}`);
        const v = {};
        (res.data || []).forEach(row => { v[row.month] = !!row.visible; });
        setVis(v);
      } finally {
        setLoading(false);
      }
    })();
  }, [year]);

  const toggleMonth = async (month) => {
    const current = !!vis[month];
    setVis(prev => ({ ...prev, [month]: !current }));
    try {
      await http.patch(`/api/admin/newsletter/${year}/${month}/visibility`, { visible: !current });
    } catch (e) {
      setVis(prev => ({ ...prev, [month]: current }));
      alert("Konnte Sichtbarkeit nicht speichern.");
    }
  };

  return (
    <div className="bg-gray-200 pt-24">
      <Navbar />
      <h1 className="text-3xl font-bold mb-6 w-1/2 m-auto mt-5">Newsletter {year}</h1>

      <table className="table-auto w-1/2 m-auto border">
        <thead>
          <tr className="bg-gray-300">
            <th className="p-3 border">Monat</th>
            <th className="p-3 border">Sichtbar (Public)</th>
            <th className="p-3 border">Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            Array.from({ length: 12 }).map((_, i) => (
              <tr key={i} className="animate-pulse">
                <td className="p-3 border"><div className="h-4 bg-gray-300 rounded w-24" /></td>
                <td className="p-3 border text-center"><div className="h-8 bg-gray-300 rounded w-24 mx-auto" /></td>
                <td className="p-3 border text-center"><div className="h-8 bg-gray-300 rounded w-24 mx-auto" /></td>
              </tr>
            ))
          ) : (
            months.map((name, index) => {
              const m = index + 1;
              const isVisible = !!vis[m];
              return (
                <tr key={index} className="text-center">
                  <td className="p-3 border text-left">{name}</td>
                  <td className="p-3 border">
                    <button
                      onClick={() => toggleMonth(m)}
                      className={`px-4 py-1 rounded font-semibold transition ${isVisible ? "bg-green-600 text-white" : "bg-gray-400 text-white"} hover:ring-2`}
                      title={isVisible ? "In öffentlicher Liste sichtbar – klicken zum Ausblenden" : "In öffentlicher Liste ausgeblendet – klicken zum Anzeigen"}
                    >
                      {isVisible ? "Öffentlich" : "Ausgeblendet"}
                    </button>
                  </td>
                  <td className="p-3 border">
                    <button
                      className="bg-blue-500 text-white px-4 py-1 rounded hover:ring-2 mr-2"
                      onClick={() => navigate(`/admin/newsletter/${year}/${m}`)}
                    >
                      Bearbeiten
                    </button>
                    <a
                      className="bg-blue-500 text-white px-4 py-1 rounded hover:ring-2"
                      href={`/newsletter/${year}/${m}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Öffnen
                    </a>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>

      <Footer />
    </div>
  );
};

export default NewsletterList;

